import { existsSync } from 'fs';
import { dirname, join } from 'path';
import { fileURLToPath } from 'url';

function findPackageRoot(): string {
  // Walk up from current file until we find package.json
  let dir = dirname(fileURLToPath(import.meta.url));
  while (!existsSync(join(dir, 'package.json'))) {
    const parent = dirname(dir);
    if (parent === dir) throw new Error('Cannot find package root');
    dir = parent;
  }
  return dir;
}

const PKG_ROOT = findPackageRoot();
export const TEMPLATES_DIR = join(PKG_ROOT, 'templates');
export const SHARED_SERVICES_PATH = join(PKG_ROOT, 'shared-services.yaml');
